import { url } from 'utils/urls';
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const fetchUDCSettings = (embedUUID, cookieId) => {
    const requestUrl = `${url.api.contents}/addons?embed_uuid=${embedUUID}&cookie_id=${cookieId}&content_type=USER_DATA_COLLECTION`;
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', requestUrl, true);
        xhr.responseType = 'text';
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(JSON.parse(xhr.response));
            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        xhr.send(null);
    });
};


export const postUDCResponse = userData => {
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.open('POST', url.api.questionResponses);
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve({
                    status: this.status,
                    response: xhr.response.length > 0 ? JSON.parse(xhr.response) : xhr.response
                })

            } else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText,
                    response: xhr.response
                });
            }
        };
        xhr.onerror = function () {
            reject({
                status: this.status,
                statusText: xhr.statusText
            });
        };
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send(JSON.stringify(userData));
    })
};
